import { createContext, useContext, useState } from "react";

const DemoModalContext = createContext(null);

export function DemoModalProvider({ children }) {
  // Estado independiente por modal: abrir uno no afecta al otro.
  const [open, setOpen] = useState(false);          // DemoRequestModal (probar demo / prueba)
  const [freeOpen, setFreeOpen] = useState(false);  // FreePlanModal (plan Gratis)
  return (
    <DemoModalContext.Provider
      value={{
        open,
        openModal: () => setOpen(true),
        closeModal: () => setOpen(false),
        freeOpen,
        openFreeModal: () => setFreeOpen(true),
        closeFreeModal: () => setFreeOpen(false),
      }}
    >
      {children}
    </DemoModalContext.Provider>
  );
}

export function useDemoModal() {
  const context = useContext(DemoModalContext);
  if (!context) throw new Error("useDemoModal debe usarse dentro de DemoModalProvider");
  return context;
}
